export enum DashboardViewType {
  NONE = 0,
  PROPERTY_VIEW = 1,
  PORTFOLIO_WIDE_VIEW = 2,
  PROPERTY_WITH_GROUPING_VIEW = 3,
  PROPERTY_WITHOUT_ALL = 4,
  PROPERTY_VIEW_SINGLE = 5,
}
